import { SVGAttributes } from 'react';

const ArrowRight = (props: SVGAttributes<SVGElement>) => (
    <svg width="7" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 16" {...props}>
        <g fill="none" fillRule="evenodd">
            <g transform="matrix(-1 0 0 1 27 -16)">
                <path stroke="currentColor" strokeWidth="1.6" d="M26.4 16.8L19.2 24l7.2 7.2" />
            </g>
        </g>
    </svg>
);

export default ArrowRight;
